import { Injectable } from '@angular/core';

@Injectable()
export class NotificationService {

  constructor() { }

  showMessage(msg: string, type?:string, title?: string, config?: any){

  }
}
